import { render, staticRenderFns } from "./RecentTicketComments.vue?vue&type=template&id=e1a9da06&scoped=true"
import script from "./RecentTicketComments.vue?vue&type=script&lang=js"
export * from "./RecentTicketComments.vue?vue&type=script&lang=js"
import style0 from "./RecentTicketComments.vue?vue&type=style&index=0&id=e1a9da06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a9da06",
  null
  
)

export default component.exports